import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Crabs from '../../components/Crabs/Crabs';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardCrabs extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Crabs/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Pacific Waters"
   diagnosis="The Dungeness crab, also known as Metacarcinus magister, is a species of crab that inhabits eelgrass beds and water bottoms on the Pacific Northwest. It is one of the most profitable fisheries on the west coast."
   prediction="Increasing acidity is harming larval crabs. Any fluctuation in crab stock could ripple through the food web, and threaten the viability of regional fisheries (NOAA)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardCrabs;
